<template>
  <div id="app">
    <NavigationBar
      :title="title"
      :icon-collect="true"
      :article-collect="articleCollect"
      @tap-collect="_tapCollect"
    />
    <div class="retieDtail">
      <h2 class="article-title two-line">{{ content.title }}</h2>
      <div class="article-infor">
        <div class="left">
          <img :src="content.imageUrl">
        </div>
        <div class="infor">
          <h3>{{ content.accountName }}</h3>
          <p>
            <span>{{ content.formatInputTime }}</span>
            <span v-show="showContentViews">阅读&nbsp;&nbsp;{{ content.views }}</span>
          </p>
        </div>
        <div class="right" @click="_tapConcern">
          <a v-show="!concern" :tjjj="'click_m_material_famous_concern_' + content.id" class="btn"><i class="iconfont icon-jiahao" />关注</a>
          <a
            v-show="concern"
            :tjjj="'click_m_material_famous_concern_' + content.id"
            class="btn gray"
          >已关注</a>
        </div>
      </div>
      <div v-if="video" class="article-content">
        <video class="video-show" :poster="content.thumb" controls="true">
          <source :src="video.url" type="video/mp4">
        </video>
      </div>
      <div v-else class="article-content" v-html="content.content" />
      <HotItem :products="products" :tjjj-prefix="tjjjPrefix + 'bindsku_'" />
      <!-- <BrandShow :brand="brand" :tjjj="tjjjPrefix + 'brandbottom'" /> -->
      <div class="article-brand shadow">
        <div class="left"><img :src="brand.brandLogo"></div>
        <div class="infor">
          <h3>{{ brand.brandName }}</h3>
        </div>
        <div class="right">
          <a
            class="btn"
            :tjjj="'click_m_material_famous_seebrand_' + content.id"
            @click="_toBrandHome"
          >进入该品牌</a>
        </div>
      </div>
      <div v-show="showAds" class="banner">
        <div class="img-list">
          <div class="swiper-wrapper">
            <div v-for="(item, index) in ads" :key="item.id" class="swiper-slide course-item ">
              <a @click="_swiperBigImgbanner(index)">
                <img :src="item.adUrl">
              </a>
            </div>
          </div>
          <div class="swiper-pagination" />
        </div>
      </div>
      <div v-if="!fromBrandhallIndex">
        <h2 v-show="showRecommendList" class="title">相关推荐</h2>
        <RecommendList
          :brand-id="brand.brandId"
          :article-type="articleType"
          :zixun-id="content.id"
          :source-type="sourceType"
          :exclude-item-ids="recommendExcludeItemIds"
          :tjjj-prefix="tjjjPrefix"
          @has-data="_showRecommendList"
        />
      </div>
      <h2 class="title">热门评论</h2>
      <CommontList :zixun-id="content.id" @has-data="_showCommontList" />
    </div>
    <BottomBtn
      :brand-id="brand.brandId"
      :article-type="type"
      :tjjj-prefix="tjjjPrefix"
      :brand-name="brand.brandName"
      :article-info="articleInfo"
      :article-like="articleLike"
      :article-collect="articleCollect"
      :trigger-reservation-show="triggerReservationShow"
      :custom-btn-tjjj="`click_m_material_brandtiezi_footsignup_` + content.id"
      :custom-reserve-btn-tjjj="customReserveBtnTjjj"
      :btn-content="btnTitle"
      :type="articleType"
      @tap-collect="_tapCollect"
      @tap-comment="_tapComment"
      @tap-zan="_tapZan"
      @reservation-show="_reservationShow"
    />
    <div v-if="articleType === 'JOINUS'" class="fix-right zsjm">
      <a :tjjj="'click_m_material_brandtiezi_signup_' + content.id" @click="_tapSignup">
        <span>{{ btnTitle }}</span>
      </a>
    </div>
    <div v-else>
      <div v-if="showFixRight" class="fix-right">
        <a :tjjj="`click_m_material_brandtiezi_signup_` + content.id" @click="_tapSignup">
          <img :src="fixRightBtn" alt="">
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import jsonp from 'easy-jsonp';
import Vue from 'vue';
import Swiper from 'swiper';
import { Toast } from 'vant';
import axios from 'axios';
import qs from 'qs';
import BottomBtn from '../../components/BottomBtn.vue';
// import BrandShow from '../../components/BrandShow.vue';
import CommontList from '../../components/CommontList.vue';
import HotItem from '../../components/HotItem.vue';
import NavigationBar from '../../components/NavigationBar.vue';
import RecommendList from '../../components/RecommendList.vue';
import Util from '../../lib/util';
import nativeBrandIndex from '../../filters/nativeBrandIndex';

Vue.use(Toast);
export default {
  name: 'App',
  components: {
    CommontList,
    RecommendList,
    // BrandShow,
    HotItem,
    NavigationBar,
    BottomBtn,
  },
  data() {
    return {
      brand: {
        brandId: 0,
      },
      content: {},
      video: null,
      products: null,
      articleType: '',
      sourceType: 'article',
      showRecommendList: false,
      recommendExcludeItemIds: [],
      title: '',
      tjjjPrefix: '',
      showContentViews: false,
      ads: [],
      type: true,
      concern: false,
      articleCollect: false,
      articleLike: false,
      fixRightBtn:
        'http://imgmall.tg.com.cn/WANGPU/2019/04/25/0924/yWkG91QBd8N8PTEKGctfj2Wy6TCy.gif',
      defaultUserPhoto: 'http://fastued3.jia.com/image/mobile/wxStore/userDefault.jpg',
      loading: false,
      showAds: false,
      articleInfo: {},
      login: false,
      loginUrl: '',
      showFixRight: false,
      triggerReservationShow: false,
      customReserveBtnTjjj: '',
      fromBrandhallIndex: false,
      btnTitle: '',
    };
  },
  watch: {
    loading: (val) => {
      if (val) {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          message: '加载中...',
        });
      } else {
        Toast.clear(true);
      }
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this._initData();
    });
  },
  methods: {
    _initData() {
      this.brand = globalData.brand;
      globalData.linkedShop = globalData.brand.linkedShop;
      if (globalData.ads && Util.isArray(globalData.ads) && globalData.ads.length > 0) {
        this.showAds = true;
        globalData.ads.forEach((ad) => {
          ad.adUrl = Util.complementImageUrl(ad.adUrl);
        });
      }
      if (globalData.ads.length !== 0 && globalData.ads.length !== 1) {
        const banner = new Swiper('.banner .img-list', {
          observer: true,
          observeParents: true,
          initialSlide: 0,
          autoplay: {
            delay: 4000,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        });
        banner.update();
      }
      if (globalData.products && Util.isArray(globalData.products)) {
        globalData.products.forEach((product) => {
          product.imgUrl = Util.complementImageUrl(product.imgUrl);
          this.recommendExcludeItemIds.push(product.productId);
        });
      }
      if (!globalData.content.imageUrl) globalData.content.imageUrl = this.defaultUserPhoto;
      let { clicks } = globalData.content;
      if (!clicks) clicks = 0;
      if (globalData.content.id) clicks += globalData.content.id % 10;
      this.articleInfo = {
        favoriteCount: globalData.content.favoriteCount,
        clicks,
        commentCount: '0',
      };
      Object.assign(this.$data, globalData);
      this._getArticleCount();
      this._ansyCollect();
      if (globalData.articleType === 'HOTSALE') {
        this.sourceType = 'product';
      } else if (globalData.articleType === 'JOINUS') {
        this.btnTitle = '加盟咨询';
        this.type = false;
      }
      this.tjjjPrefix = `click_m_brands_${this.articleType}_${this.brand.brandPinyin}_`;
      this.customReserveBtnTjjj = `click_m_material_brandtiezi_footsignup_subbtn_${
        this.content.id
      }`;
      this.$nextTick(() => {
        this._clearImageWidth();
        const UA = window.navigator.userAgent;
        const isWeiXin = /MicroMessenger/i.test(UA);
        this.showFixRight = !isWeiXin;
        if (!this.login) window.onPageResume = this._onPageResume;
      });
    },

    _clearImageWidth() {
      // 内嵌图片有内联样式 width，则替换为 100%，并将父元素强制为 display: block
      document.querySelectorAll('.article-content img').forEach((img) => {
        if (img.style.width && img.style.width !== '' && Number.parseFloat(img.style.width) > 100) {
          img.style.width = '100%';
          if (img.parentNode) {
            const pDisplay = window.getComputedStyle(img.parentNode).display;
            if (pDisplay === 'inline' || pDisplay === 'inline-block') { img.parentNode.style.display = 'block'; }
          }
        }
      });
    },

    _toBrandHome() {
      window.location.href = nativeBrandIndex(`${globalRootUrl}ppzq/brand-${this.brand.brandId}/`);
    },

    _showRecommendList() {
      this.showRecommendList = true;
    },

    _showCommontList(e) {
      this.articleInfo = {
        commentCount: e,
        favoriteCount: this.articleInfo.favoriteCount,
        clicks: this.articleInfo.clicks,
      };
    },

    _loginRequired() {
      if (!this.login) window.location.href = this.loginUrl;
      return this.login;
    },

    _onPageResume() {
      const isApp = navigator.userAgent.indexOf('QIJIA') > -1
        || typeof Device !== 'undefined'
        || navigator.userAgent.indexOf('ZXTTAPP') > -1;
      const UA = window.navigator.userAgent;
      const IsAndroid = /Android|HTC/i.test(UA);
      const IsIPad = !IsAndroid && /iPad/i.test(UA);
      const IsIPhone = !IsAndroid && /iPod|iPhone/i.test(UA);
      const IsIOS = IsIPad || IsIPhone;
      if (isApp && IsIOS) {
        axios
          .get(`${globalRootUrl}auth/status/`)
          .then((res) => {
            const { data } = res;
            if (!data) throw new Error('获取登录状态失败');
            const { access } = data;
            if (access === true) {
              window.location.reload();
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      }
    },
    _getArticleCount() {
      jsonp({
        url: '//mp.jia.com/count/v.php',
        callback: `callback_${Util.getRandomString(8)}`,
        timeout: 3000,
        params: {
          id: this.content.id,
        },
      })
        .then((res) => {
          if (!res || !res.data) return;
          const views = res.data.read_total;
          this.content.views = views;
          this.showContentViews = true;
        })
        .catch((err) => {
          this.showContentViews = true;
          console.warn(err);
        });
    },

    _swiperBigImgbanner(index) {
      if (this.ads[index].adLink) {
        window.location.href = this.ads[index].adLink;
      }
    },

    _ansyCollect() {
      this.loading = true;
      axios({
        url: '/zixun/ajax_user_is_wzsc/',
        method: 'post',
        data: qs.stringify(
          Util.bulidUserParamsForApp({
            id: this.content.id,
            dy_id: this.content.userId,
          }),
        ),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
        .then((res) => {
          const { data } = res;
          if (!data) throw new Error('获取文章信息异常');
          const { wzsc, wzdy, wzdz } = data;
          if (wzdy === 'success') this.concern = true;
          if (wzsc === 'success') this.articleCollect = true;
          if (wzdz === 'success') this.articleLike = true;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.warn(err);
        });
    },

    _tapConcern() {
      if (!this._loginRequired()) return;
      const type = this.concern ? 2 : 1;
      const userData = Util.bulidUserParamsForApp();
      const action = this.concern ? '取消关注' : '关注';
      const params = {
        id: this.content.userId,
        ftype: 1,
        type,
        uid: userData.userId,
        md5_userId: userData.md5_userId,
        from_url: encodeURIComponent(window.location.href),
      };
      axios
        .get('/zixunUser/ajax_focus', {
          params,
        })
        .then((res) => {
          const { data } = res;
          if (!data || data.respcode !== 0) throw new Error(`${action}失败`);
          const { statusCode } = data;
          if (statusCode === '0000') {
            Toast.success(`${action}成功`);
            this.concern = !this.concern;
          } else {
            Toast.fail(`${action}失败`);
          }
        })
        .catch((err) => {
          console.warn(err);
          Toast.fail(err.message);
        });
    },

    _tapCollect() {
      if (typeof TJJ !== 'undefined') { TJJ.action({ tjjj: `click_m_material_famous_collect_${this.content.id}` }); }
      if (!this._loginRequired()) return;
      const type = this.articleCollect ? 'del' : 'add';
      const action = this.articleCollect ? '取消收藏' : '收藏';
      this.loading = true;
      axios({
        url: '/zixun/ajax_wzsc/',
        method: 'post',
        data: qs.stringify(
          Util.bulidUserParamsForApp({
            id: this.content.id,
            type,
          }),
        ),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
        .then((res) => {
          const { data } = res;
          if (!data || data.code !== 1) throw new Error(`${action}失败`);
          this.articleCollect = !this.articleCollect;
          if (this.articleCollect) {
            this.articleInfo.favoriteCount++;
          } else {
            this.articleInfo.favoriteCount--;
          }
          Toast.success(`${action}成功`);
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .catch((err) => {
          console.warn(err);
          setTimeout(() => {
            this.loading = false;
          }, 500);
          Toast.fail(err.message);
        });
    },
    _tapComment() {
      if (typeof TJJ !== 'undefined') { TJJ.action({ tjjj: `click_m_material_famous_answer_${this.content.id}` }); }
      if (!this._loginRequired()) return;
      window.location.href = `/zixun/pinglunPage?id=${
        this.content.id
      }&return_url=${encodeURIComponent(window.location.href)}`;
    },
    _tapZan() {
      if (typeof TJJ !== 'undefined') { TJJ.action({ tjjj: `click_m_material_famous_givelike_support_${this.content.id}` }); }
      if (!this._loginRequired()) return;
      if (!this.articleLike) {
        this.loading = true;
        axios({
          url: '/zixun/ajax_like_news/',
          method: 'post',
          data: qs.stringify(
            Util.bulidUserParamsForApp({
              id: this.content.id,
            }),
          ),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
          .then((res) => {
            const { data } = res;
            if (!data) throw new Error('文章点赞异常');
            const { status } = data;
            if (status === 'yes') {
              this.articleInfo.clicks += 1;
              this.articleLike = true;
            } else if (status === 'old_like') {
              this.articleLike = true;
            }
            setTimeout(() => {
              this.loading = false;
            }, 500);
          })
          .catch((err) => {
            this.loading = false;
            console.warn(err);
          });
      }
    },
    _tapSignup() {
      this.triggerReservationShow = true;
      this.customReserveBtnTjjj = `click_m_material_brandtiezi_signup_subbtn_${this.content.id}`;
    },
    _reservationShow(e) {
      if (e) this.triggerReservationShow = false;
      else {
        this.customReserveBtnTjjj = `click_m_material_brandtiezi_footsignup_subbtn_${
          this.content.id
        }`;
      }
    },
  },
};
</script>

<style lang="less">
@import "../../style/common.less";
@import "../../style/swiper.min.css";

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.one-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 两行省略号 */
.two-line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.retieDtail {
  padding: 0 28px;
  margin-bottom: calc(138px + constant(safe-area-inset-bottom));
  margin-bottom: calc(138px + env(safe-area-inset-bottom));
  margin-bottom: 138px;
}

.article-title {
  color: #333;
  font-size: 48px;
  line-height: 70px;
}

.title {
  font-size: 36px;
  color: #000028;
  margin-top: 100px;
  margin-bottom: 34px;
}

.article-infor {
  display: flex;
  align-items: center;
  justify-content: center;

  .left {
    margin-right: 20px;
    width: 60px;
    height: 60px;
    display: flex;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .infor {
    flex: auto;
    line-height: 10px;

    h3 {
      font-size: 30px;
      color: #333;
    }

    p {
      color: #999;
      font-size: 22px;

      span:first-child {
        padding-right: 40px;
      }
    }
  }

  .right {
    display: flex;
    line-height: 35px;
    align-items: center;

    .btn {
      text-decoration: none;
      display: inline-block;
      color: #ee2d1b;
      font-weight: 500;
      font-size: 24px;
      background-color: #fef4f3;
      border: 2px solid rgba(238, 45, 27, 0.5);
      border-radius: 50px;
      padding: 6px 22px;
      line-height: 35px;

      &.gray {
        background: #fafafa;
        color: #999;
        border: 2px solid #e0e0e0;
      }
    }

    .icon-jiahao {
      font-size: 26px;
      font-weight: 700;
      margin-right: 5px;
    }
  }
}

/* zixun 文章样式兼容 */
.article-content {
  color: #333;
  font-size: 30px;
  line-height: 50px;

  &.special_article {
    font-size: 32px;

    section strong span {
      font-weight: bold;
    }
  }

  a {
    color: #e55f2e;
  }

  p {
    margin-bottom: 50px;
  }

  img {
    max-width: 100%;
    width: auto;
    height: auto !important;
  }

  section,
  div {
    max-width: 100%;
    box-sizing: border-box;
  }

  .common-edit {
    width: 100% !important;
    box-sizing: border-box;
  }

  .video-content {
    margin: 0 -28px;
  }

  .more-shop-list p {
    margin-bottom: 0;
  }

  .block-content {
    &.zq,
    &.zq .sub-block-content,
    &.zq .zq-p {
      width: 100% !important;
      box-sizing: border-box;
    }

    &.zq section section,
    &.zq section section > section:nth-child(4),
    section section > section:nth-child(6) {
      width: 100% !important;
    }

    &.zq section section > section {
      width: auto !important;
    }
  }
}

.video-show {
  width: 100%;
  height: 420px;
}

.article-brand {
  border-radius: 20px;
  padding: 0 24px;
  margin-top: 75px;
  height: 130px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  .left {
    margin-right: 20px;
    width: 118px;
    height: 58px;
    background-color: #fff;
    display: flex;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .infor {
    flex: auto;

    h3 {
      font-size: 30px;
      color: #333;
    }
  }

  .right {
    display: flex;

    .btn {
      color: #fff;
      width: 138px;
      height: 52px;
      line-height: 52px;
      border-radius: 26px;
      border: none;
      padding-left: 28px;
      padding-right: 28px;
      .common-button-style();
      .font-small();
    }
  }
}

.banner {
  margin-top: 60px;
  width: 694px;
  height: 347px;
  overflow: hidden;
  border-radius: 20px;
  position: relative;
  z-index: 2;

  .img-list {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.fix-right {
  position: fixed;
  right: 4px;
  width: 135px;
  height: 126px;
  top: 46%;
  z-index: 99;

  &.zsjm {
    right: 28px;
    width: 100px;
    height: 100px;
    background: linear-gradient(-90deg, rgba(238, 45, 27, 1), rgba(255, 102, 51, 1));
    box-shadow: 0 10px 30px 0 rgba(238, 45, 27, 0.3);
    border-radius: 50%;
    top: 46%;
    z-index: 99;
    color: #fff;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      display: flex;
      flex-flow: column;
      align-items: center;

      span {
        width: 50px;
        line-height: 30px;
      }
    }
  }

  a {
    display: block;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
